// extracted by mini-css-extract-plugin
export default {"variables":"\"variables.css\"","first-table-shrink-width":"1050px","main":"ResetForgotPasswordLayout_main__ACqpN","authorshipInfo":"ResetForgotPasswordLayout_authorshipInfo__YAdAz"};